import { Img } from "containers/Manual/components/content/Image";
import { Paragraph } from "containers/Manual/components/content/Paragraph";
import { Li } from "containers/Manual/components/list/Li";
import { Ul } from "containers/Manual/components/list/Ul";
import { CardSection } from "containers/Manual/components/section/CardSection";
import { ListSection } from "containers/Manual/components/section/ListSection";

export const NETWORKDAYS = () => {
  return (
    <CardSection id="NETWORKDAYS" title="NETWORKDAYS">
      <Paragraph>
        두 날짜/시간 객체 사이의 일 수를 반환합니다. 이는 Excel의 NETWORKDAYS
        함수와 동일한 값을 제공합니다.
      </Paragraph>

      <ListSection title="Syntax">
        <Paragraph accent>
          NETWORKDAYS(DATE_TIME_START, DATE_TIME_END)
        </Paragraph>
        <Ul>
          <Li>
            <b>DATE_TIME_START</b>는 시작 날짜에 대한 날짜/시간 개체입니다.
          </Li>
          <Li>
            <b>DATE_TIME_END</b>는 종료 날짜에 대한 날짜/시간 개체입니다.
          </Li>
        </Ul>
      </ListSection>

      <ListSection title="Example">
        <Paragraph accent>현재 지원 준비중인 함수입니다.</Paragraph>
        {/* <Img src="computeNetworkdays" /> */}
      </ListSection>
    </CardSection>
  );
};
